import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_ACTIVITY_LOG_COL_DEF, transferRowData } from "presentation/constant/ActivityLog/ActivityLogMaintenanceColumnDefinition";
import { useActivityLogMaintenanceTracked } from "presentation/store/ActivityLog/ActivityLogMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";

const ActivityLogTablePanel: React.FC = () => {
    const [activityLogState] = useActivityLogMaintenanceTracked();
    const { tableData } = activityLogState;
    const gridRef: any = useRef(null);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
    }, [])

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='activity-log-table'
                isNewColumnSetting={true}
                columns={INITIAL_ACTIVITY_LOG_COL_DEF}
                data={transferRowData(tableData ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
            // rowSelection={"multiple"}
            />
        );
    }, [tableData, handleSelectionChange])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(ActivityLogTablePanel);
